import {SmartComponent} from "smart-component-js";
import $ from "jquery";
import GigyaManager from "../business/GigyaManager";
import Constants from "../business/Constants";
import PromoApi from "mbpromo/src/api/PromoApi";
import UrlHelper from "../helpers/url.helper";
import moment from "moment";
import Pristine from "pristinejs/dist/pristine";

class CompletaDatiCtrl extends SmartComponent {

	constructor(element, parentComponent, params) {
		super(element, parentComponent, params);

		this.userPrivacyProfiling = false;

		// regex
		this.addressValidationRegexp = /^[a-zA-Z0-9àáâäãåèéêëìíîïòóôöõøùúûüÿýñçčšžÀÁÂÄÃÅÈÉÊËÌÍÎÏÒÓÔÖÕØÙÚÛÜŸÝÑßÇŒÆČŠŽ∂ð ,.'-/°]{2,120}$/;

		this.files = [];
		this.promoApi = new PromoApi({promoCode: Constants.API_PROMOCODE});
		this.pristine;

		this.istantWin = UrlHelper.getUrlParam('iw');

		this.init();
	}
	init() {
		this.loadChildComponents(this);
		this.startLoader();

		let form = document.getElementById("template-form");

		let formConfig = {
			// class of the parent element where the error/success class is added
			classTo: 'col-form',
			errorClass: 'error',
			successClass: 'has-success',
			// class of the parent element where error text element is appended
			errorTextParent: 'col-form',
			// type of element to create for the error text
			errorTextTag: 'span',
			// class of the error text element
			errorTextClass: 'error-field'
		};



		// termine ultimo per richiedere il premio
		this.promoApi.status().then((resp) => {
			let response = resp.body.response.data;


			if(moment(response.promo.dates.prize_request_end.raw).diff(moment()) < 0){
				let tmplModalGeneric = ` <div class="feedback__modal" component="FeedbackModalComponent">
										<div class="feedback__modal__wrap">
											<div class="feedback__modal__content">
												<h2 class="h3">${response.promo.prize_request_ended_description}</h2>
												<a class="button" href="/promozioni/gioca-e-vinci-con-scacchieri/area-personale">Torna all'area personale</a>
											</div>
										</div>
									</div>`;
				$(this.element).append(tmplModalGeneric);
				this.loadChildComponents(this);
				this.removeLoader();
				return;
			} else{
				let play_token = UrlHelper.getUrlParam('pt');

				if(this.istantWin === "1"){
					$('.row-form--hide').remove();
					$('.iw-0').hide();
					$('.iw-1').show();
				}else{
					$('.iw-1').hide();
					$('.iw-0').show();
				}


				this.trimRequired();

				// init form validator
				this.pristine = new Pristine(form, formConfig);
				this.address = document.getElementById('indirizzo');


				this.regexAddress();


				GigyaManager.getLoggedUserCached().then(async (u) => {
					this.userPrivacyProfiling = u.preferences.privacy_profiling.isConsentGranted;
					this.promoApi.areaPersonale().then(async resp => {
						const win = resp.body.response.data.freeplays.filter(c =>  c.status === "WIN" && c.playdata.play_token === play_token);

						if(win.length > 0) {
							await this.buildDropdownProvince();

							window.gigyaIntegration.autocompleteForm('#template-form', (data) => {
								this.buildDropdownCities().then(() => {
									this.autocompileCity(data);
								});
							});


							// event on change provincia
							$('#provincia').change(() => {
								this.startLoader();
								this.buildDropdownCities();
							});

							this.removeLoader();
						}else{
							let tmplModalGeneric = ` <div class="feedback__modal" component="FeedbackModalComponent">
                                                        <div class="feedback__modal__wrap">
                                                            <div class="feedback__modal__content">
                                                                <h2 class="h3">Ops, il premio non risulta associato al tuo account! </h2>
                                                                <p>Stai provando a richiedere un premio che non risulta appartenere al tuo account!</p>
                                                                <a class="button" href="/promozioni/gioca-e-vinci-con-scacchieri/area-personale">Torna all'area personale</a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                `;
							$(this.element).append(tmplModalGeneric);
							this.loadChildComponents(this);
							this.removeLoader();
						}
					})
				}, () => {
					window.location.href = "/login?urlBack="+window.location.href.replace(window.location.origin, "")+"&regSource="+Constants.PROMO_CODE;
				});
			}

		});
	}



	/**
     * Build dropdown of two fields (provincia-pdv, provincia)
     * @returns {Promise<void>}
     */
	async buildDropdownProvince(){
		let options = '<option value="" default="true">Scegli la provincia</option>';

		let resp = await this.promoApi.elencoProvince();
		let provinceList = resp.body.response.data;
		for(var i = 0; i < provinceList.length; i++){
			options += `<option value="${provinceList[i].short_description}" data-id-value="${provinceList[i].id}" data-province-short-desc="${provinceList[i].short_description}" data-region-id="${provinceList[i].region.id}">${provinceList[i].description}</option>`
		}

		// build field provincia
		$('#provincia').html(options);
	}

	/**
     * Build Dropdown city by id
     * @returns {Promise<void>}
     */
	async buildDropdownCities(){
		let options = '<option value="" default="true">Scegli la città</option>';
		let dataIdProvince = $('#provincia option:selected').attr('data-id-value');
		if(dataIdProvince) {
			let resp = await this.promoApi.elencoCitta(dataIdProvince);
			let provinceList = resp.body.response.data;
			for(var i = 0; i < provinceList.length; i++){
				options += `<option value="${provinceList[i].id}" >${provinceList[i].description}</option>`
			}

			$('#citta').html(options);
			$('#citta').val("");
		}
		this.removeLoader();
	}

	/**
	 * Auto fill select by autocomplete Noovle
	 * @param {Object} data
	 */
	async autocompileCity(data){
		const city = data.profile.city;
		if(city){
			$('#citta option').filter((i, e) => {
				return $(e).text() === city
			}).attr("selected","selected");
		}
	}


	/**
	 * Trim all required fields
	 */
	trimRequired(){
		Pristine.addValidator('required', (value) => {
			return ( value.trim() !== '' );
		}, "", 5, false);
	}

	/**
	 * Check value product
	 * @param {String} idField
	 * @return {Boolean}
	 */
	validatorProduct(idField){
		let id = document.getElementById(idField);
		this.pristine.addValidator(id, (value) => {
			let productArr = this.productData.response.data.map((o) => o.code);
			if (productArr.indexOf(value) >= 0){
				return true;
			}
			return false;
		}, "", 5, false);
	}


	/**
	 * Regex address
	 */
	regexAddress(){
		this.pristine.addValidator(this.address, (value) => {
			// here `this` refers to the respective input element
			if (!this.addressValidationRegexp.test(value)){
				return false;
			}
			return true;
		}, "Il campo contiene caratteri non consentiti o supera la lunghezza massima di 120 caratteri", 2, false);
	}

	/**
	 * Submit form, start loading and init validate
	 */
	submit(){
		this.startLoader();
		this.validateForm();
	}


	sendForm(){
		let inputs = $('.col-form > input, .col-form #citta, .col-form #provincia');
		let form = {
			basedata: {
				play_token: UrlHelper.getUrlParam('pt')
			},
			customdata: {}
		};
		for(let i = 0; i < inputs.length; i++){
			let input = $(inputs[i]);
			if(input.attr("id") !== "prefix" && input.attr("id") !== "provincia"){
				form.basedata[input.attr('name')] = input.val();
			}

			if(input.attr("id") === "provincia"){
				form.basedata[input.attr('name')] = $("#provincia option:selected").data('id-value');
			}
		}

		form.basedata["user_phone"] = "39" + form.basedata["user_phone"];

		// RECEIPT IMAGE
		form.basedata.receipt_file_front = this.files[0];
		if(this.files.length > 1){
			form.basedata['receipt_file_back'] = this.files[1];
		}

		// PROFILING
		form.customdata['user_profiling'] = this.userPrivacyProfiling ? 1 : 0;


		this.promoApi.richiediPremio(form).then(()=>{
			window.location.href = "/promozioni/gioca-e-vinci-con-scacchieri/thank-you?iw=" + this.istantWin;
		}, (err)=>{
			this.removeLoader();
			let tmplModalGeneric = ` <div class="feedback__modal" component="FeedbackModalComponent">
                                                    <div class="feedback__modal__wrap">
                                                        <div class="feedback__modal__close" component-click="close()">
                                                            <svg>
                                                                <use xlink:href="#svg_circle_close"></use>
                                                            </svg>
                                                        </div>
                                                        <div class="feedback__modal__content">
                                                            <h2 class="h3">Ops, qualcosa è andato storto! </h2>
                                                            <p>${err.body.status.errors.data.description}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                               `;
			$(this.element).append(tmplModalGeneric);
			this.loadChildComponents(this);
		});
	}

	removeLoader(){
		$('.tool_loader').fadeOut(500).remove();
		$('body').removeClass('noScroll');
		$('#conferma').prop("disabled", false).removeClass('disabled');
	}

	startLoader(){
		$('.mb-promo').append('<div data-tool-loader="" class="tool_loader"><svg><use xlink:href="#svg_loader"></use></svg></div>');
		$('body').addClass('noScroll');
		$('#conferma').prop("disabled", true).addClass('disabled');
	}

	/**
	 * Validate pristine form
	 * @return {boolean}
	 */
	validateForm(){
		let valid = this.pristine.validate();

		if(valid){
			$('.error-feedback').remove();
			$('input, select').removeClass('error');

			// show modal
			this.sendForm();
		} else {
			this.removeLoader();
			this.scrollToError();
			return false;
		}
	}


	/**
	 * Scroll to error
	 */
	scrollToError(){
		$([document.documentElement, document.body]).animate({
			scrollTop: $(".error").offset().top - 25
		}, 1500);
	}
}

export default CompletaDatiCtrl;
